import { Info } from "lucide-react";
import type { RouterOutputs } from "@/trpc";

type EditRestriction =
  RouterOutputs["credentials"]["getForBu"]["access"]["restriction"];

/**
 * Why this reader cannot edit, in their terms.
 *
 * There used to be a second reason — the professional maintained their own
 * credentials, so an organization could only read. That is gone: an
 * organization now keeps its own record of a professional rather than editing
 * theirs, so whether they have claimed an account no longer decides anything.
 * Permission is the only thing left that can withhold the button.
 */
export function EditRestrictionNotice({
  restriction,
}: {
  restriction: EditRestriction;
}) {
  if (restriction === null) {
    return null;
  }

  const message =
    restriction === "ended"
      ? "This affiliation has ended. Your organization’s saved credentials and documents remain available to view."
      : "You do not have permission to edit credentials in this business unit.";

  return (
    <div className="flex items-start gap-2.5 rounded-xl border bg-white p-3">
      <Info
        className="mt-0.5 h-4 w-4 shrink-0 text-gray-400"
        aria-hidden="true"
      />
      <p className="text-sm text-gray-600">{message}</p>
    </div>
  );
}
